(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook-gallery-empire"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lookbook-slider-empire')) {
    class LookbookSliderEmpire extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.prevButton = this.querySelector('[data-slider-prev]');
        this.nextButton = this.querySelector('[data-slider-next]');
        if (!this.track || !this.prevButton || !this.nextButton) return;

        this.handlePrev = () => this.goTo(this.currentIndex() - 1);
        this.handleNext = () => this.goTo(this.currentIndex() + 1);
        this.handleScroll = () => {
          if (this.frame) cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.updateButtons());
        };

        this.prevButton.addEventListener('click', this.handlePrev);
        this.nextButton.addEventListener('click', this.handleNext);
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.handleScroll);
          this.resizeObserver.observe(this.track);
        }

        this.initialised = true;
        this.updateButtons();
      }

      disconnectedCallback() {
        if (!this.initialised) return;
        this.prevButton.removeEventListener('click', this.handlePrev);
        this.nextButton.removeEventListener('click', this.handleNext);
        this.track.removeEventListener('scroll', this.handleScroll);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.initialised = false;
      }

      currentIndex() {
        const width = this.track.clientWidth;
        return width ? Math.round(this.track.scrollLeft / width) : 0;
      }

      goTo(index) {
        const lastIndex = this.track.children.length - 1;
        const target = Math.max(0, Math.min(lastIndex, index));
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.track.scrollTo({
          left: target * this.track.clientWidth,
          behavior: reduceMotion ? 'auto' : 'smooth',
        });
      }

      updateButtons() {
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        this.prevButton.disabled = this.track.scrollLeft <= 1;
        this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 1;
      }
    }

    customElements.define('lookbook-slider-empire', LookbookSliderEmpire);
  }

  } catch(e) { console.error(e); }
})();
})();
